/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon20Light = forwardRef('LogoMicrosoftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3.5A1.5 1.5 0 0 1 3.5 2h12A1.5 1.5 0 0 1 17 3.5v12a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 2 15.5v-12ZM3 10v5.5a.5.5 0 0 0 .5.5H9v-6H3Zm6-1H3V3.5a.5.5 0 0 1 .5-.5H9v6Zm1 1v6h5.5a.5.5 0 0 0 .5-.5V10h-6Zm6-1h-6V3h5.5a.5.5 0 0 1 .5.5V9Z" })));
});
